import { StyleSheet } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  cardStyle: theme => ({
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6,
    paddingVertical: 15,
    shadowColor: Colors.blackThree,
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.16,
    shadowRadius: 8,
    elevation: 4,
  }),
  lineBottom: theme => ({
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.borderColorFour,
  }),
  title: theme => ({
    fontSize: 18,
    color: theme.colors.textColorThree,
    ...Fonts.type.bold,
  }),
  subtitle: theme => ({
    fontSize: 16,
    marginTop: 5,
    lineHeight: 22,
    color: theme.colors.textColorThree,
  }),
  logo: {
    width: 32,
    height: 32,
    marginRight: 16,
  },
  arrow: {
    width: 32,
    height: 32,
  },
});
